import { Icon } from '@types';

export const Arrow = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="#323f57"
			width="20px"
			height="20px"
			onClick={handleClick}
		>
			<path d="M0 0h24v24H0V0z" fill="none" opacity=".87" />
			<path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z" />
		</svg>
	);
};
